// COPY de apps/desktop/src/features/knowledge/status.ts; dedup em F13.
import type { components } from '@copilot/shared-types';

export type KnowledgeStatus = components['schemas']['KnowledgeDocumentPublic']['status'];
export type KnowledgeDocType = components['schemas']['KnowledgeDocumentPublic']['doc_type'];

const STATUS_LABELS: Record<KnowledgeStatus, string> = {
  pending: 'Pendente',
  processing: 'Processando',
  indexed: 'Indexado',
  failed: 'Falhou',
};

const DOC_TYPE_LABELS: Record<KnowledgeDocType, string> = {
  battlecard: 'Battlecard',
  product: 'Produto',
  faq: 'FAQ',
  process: 'Processo',
  other: 'Outro',
};

export function formatKnowledgeStatus(status: KnowledgeStatus): string {
  return STATUS_LABELS[status];
}

export function formatKnowledgeDocType(type: KnowledgeDocType): string {
  return DOC_TYPE_LABELS[type];
}

export const KNOWLEDGE_STATUS_OPTIONS: readonly { value: KnowledgeStatus | ''; label: string }[] = [
  { value: '', label: 'Todos os status' },
  { value: 'pending', label: STATUS_LABELS.pending },
  { value: 'processing', label: STATUS_LABELS.processing },
  { value: 'indexed', label: STATUS_LABELS.indexed },
  { value: 'failed', label: STATUS_LABELS.failed },
];

export const KNOWLEDGE_DOC_TYPE_OPTIONS: readonly {
  value: KnowledgeDocType | '';
  label: string;
}[] = [
  { value: '', label: 'Todas as categorias' },
  { value: 'battlecard', label: DOC_TYPE_LABELS.battlecard },
  { value: 'product', label: DOC_TYPE_LABELS.product },
  { value: 'faq', label: DOC_TYPE_LABELS.faq },
  { value: 'process', label: DOC_TYPE_LABELS.process },
  { value: 'other', label: DOC_TYPE_LABELS.other },
];

export const KNOWLEDGE_MAX_SIZE_BYTES = 25 * 1024 * 1024;
export const KNOWLEDGE_ALLOWED_EXTENSIONS: readonly string[] = [
  '.pdf',
  '.docx',
  '.pptx',
  '.txt',
  '.md',
];

export interface FileValidation {
  ok: boolean;
  reason?: 'too_large' | 'unsupported_type';
  message?: string;
}

export function validateKnowledgeFile(file: File): FileValidation {
  const lowered = file.name.toLowerCase();
  const matched = KNOWLEDGE_ALLOWED_EXTENSIONS.some((ext) => lowered.endsWith(ext));
  if (!matched) {
    return {
      ok: false,
      reason: 'unsupported_type',
      message: `Tipo não suportado. Aceitos: ${KNOWLEDGE_ALLOWED_EXTENSIONS.join(', ')}.`,
    };
  }
  if (file.size > KNOWLEDGE_MAX_SIZE_BYTES) {
    return {
      ok: false,
      reason: 'too_large',
      message: `Arquivo excede o limite de ${KNOWLEDGE_MAX_SIZE_BYTES / (1024 * 1024)} MB.`,
    };
  }
  return { ok: true };
}

export function formatFileSize(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
